import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
// import resumeIcon from "../images/resume-icon.png";
// import linkedinIcon from "../images/linkedin-icon.png";

export function Nav({ color }) {
  const location = useLocation();
  const textClass =
    color === "white"
      ? "white-text"
      : color === "black"
      ? "black-text"
      : color === "gray"
      ? "gray-text"
      : "white-text";

  const isCurrentPage = (path) => {
    if (path === "/about") {
      return location.pathname === "/about";
    }
    if (path === "/#projects") {
      const isOnHomePage = location.pathname === "/";
      const hasProjectsHash = location.hash === "#projects";

      return isOnHomePage || hasProjectsHash;
    }
    return false;
  };

  return (
    <nav
      id="nav-container"
      className={
        color === "white" || color === "gray" ? "black-bg" : "white-bg"
      }
    >
      <Link to="/#" className={`logo ${textClass}`}>
        MANDY &nbsp;|&nbsp; TSAICHEN LIN
      </Link>
      <div className="nav-button-container">
        <HashLink
          smooth
          to="/#projects"
          className={`nav-button ${textClass} ${
            isCurrentPage("/#projects") ? "current-page" : ""
          }`}
          scroll={(el) => {
            setTimeout(() => {
              el.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 150);
          }}
          /*
          onMouseEnter={(e) => {
            e.preventDefault();
            document.getElementById("project-section")?.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }}*/
        >
          Projects
        </HashLink>
        <Link
          to="/about"
          className={`nav-button ${textClass} ${
            isCurrentPage("/about") ? "current-page" : ""
          }`}
        >
          About
        </Link>
        <a
          href="https://drive.google.com/file/d/14FQzy95ZXVxBhjebluuehrxgVvG20mMy/view?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
          className={`nav-button ${textClass}`}
        >
          Resume
        </a>
        <a
          href="https://www.linkedin.com/in/tsai-chen-lin/"
          target="_blank"
          rel="noopener noreferrer"
          className={`nav-button ${textClass}`}
        >
          LinkedIn
        </a>
      </div>
    </nav>
  );
}

export function Footer({ color }) {
  const footerClass =
    color === "white" ? "white-bg black-text" : "black-bg white-text";
  const linkClass =
    color === "white" ? " nav-button black-text" : "nav-button white-text";

  return (
    <footer className={footerClass}>
      <div id="quick-links">
        <a
          href="https://drive.google.com/file/d/14FQzy95ZXVxBhjebluuehrxgVvG20mMy/view?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
          className={linkClass}
        >
          Resume
        </a>
        <a
          href="https://www.linkedin.com/in/tsai-chen-lin/"
          target="_blank"
          rel="noopener noreferrer"
          className={linkClass}
        >
          LinkedIn
        </a>
        <a
          href="mailto:linmandy27@gmail.com"
          className={linkClass}
          id="footer-email"
        >
          linmandy27@gmail.com
        </a>
      </div>
      <HashLink
        to="/#nav-container"
        className={`logo  ${linkClass}`}
        scroll={(el) => {
          if (window.location.pathname === "/") {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }}
      >
        MANDY &nbsp;|&nbsp; TSAICHEN LIN
      </HashLink>
    </footer>
  );
}
